import { GET_WEATHER_RESPONSE, GET_WEATHER_REQUEST, GET_WEATHER_FAIL } from "./actions";

const initialState = {
    isLoading: false,
    error: null,
    data: {
        location: null,
        current: null,
        forecast: [],
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_WEATHER_REQUEST:
            return {
                ...state, 
                isLoading: action.isLoading,
                error: null,
            };
        case GET_WEATHER_RESPONSE: 
            return {
                ...state,
                isLoading: false,
                error: null,
                data: action.weatherData,
            };
        case GET_WEATHER_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        
        default: 
            return state;
    }
}